'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _browser = require('../../../utils/services/browser');

var _createMilanoteEditor = require('../milanoteEditor/createMilanoteEditor');

var _createMilanoteEditor2 = _interopRequireDefault(_createMilanoteEditor);

var _linkify = require('../plugins/linkify');

var _linkify2 = _interopRequireDefault(_linkify);

var _checklist = require('../plugins/checklist');

var _checklist2 = _interopRequireDefault(_checklist);

var _deleteOnEmpty = require('../plugins/deleteOnEmpty');

var _deleteOnEmpty2 = _interopRequireDefault(_deleteOnEmpty);

var _markdownSupport = require('../plugins/markdownSupport');

var _markdownSupport2 = _interopRequireDefault(_markdownSupport);

var _editingHelper = require('../plugins/editingHelper');

var _editingHelper2 = _interopRequireDefault(_editingHelper);

var _milanoteShortcuts = require('../plugins/milanoteShortcuts');

var _milanoteShortcuts2 = _interopRequireDefault(_milanoteShortcuts);

var _stopEditingOnBlur = require('../plugins/stopEditingOnBlur');

var _stopEditingOnBlur2 = _interopRequireDefault(_stopEditingOnBlur);

require('./RichTextEditor.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Plugins
// Utils
var checklistPlugin = (0, _checklist2.default)();

// Styles


// Editor

var deleteOnEmptyPlugin = (0, _deleteOnEmpty2.default)();
var markdownPlugin = (0, _markdownSupport2.default)();
var editingHelperPlugin = (0, _editingHelper2.default)();
var milanoteShortcutsPlugin = (0, _milanoteShortcuts2.default)();
var linkifyPlugin = (0, _linkify2.default)();
var stopEditingOnBlurPlugin = (0, _stopEditingOnBlur2.default)();

var plugins = [linkifyPlugin, deleteOnEmptyPlugin, checklistPlugin, markdownPlugin, editingHelperPlugin, milanoteShortcutsPlugin];

// Only stop editing for iPhones
if ((0, _browser.isMobile)() && _browser.isApple) {
    plugins.push(stopEditingOnBlurPlugin);
}

exports.default = (0, _createMilanoteEditor2.default)(plugins, { className: 'RichTextEditor' });


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/richText/RichTextEditor.js
// module id = 1745
// module chunks = 0